var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationWomanOnlineMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 236.85 179.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.78,
    y1: 537.83,
    x2: 1.58,
    y2: 537.64,
    gradientTransform: "matrix(52.93 0 0 -35.76 42.83 19334.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.82,
    y1: 531.01,
    x2: 1.3,
    y2: 530.67,
    gradientTransform: "matrix(43.55 0 0 -25.69 29.51 13785.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7f3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.33,
    y1: 520.5,
    x2: 0.74,
    y2: 520.06,
    gradientTransform: "matrix(26.11 0 0 -17.98 42.05 9434.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843c09",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2.04,
    y1: 537.08,
    x2: 1.9,
    y2: 537.14,
    gradientTransform: "matrix(64.69 0 0 -34.67 47.7 18696.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#dc841e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.83,
    y1: 531.61,
    x2: 1.31,
    y2: 531.26,
    gradientTransform: "matrix(43.54 0 0 -26.33 -26.72 14107.68)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("style", null, ".cls-6{fill:#68e1fd}.cls-8{fill:#999a1c}.cls-10{fill:#f47b56}.cls-11{fill:#fff}.cls-15{fill:#f2f2f2}.cls-16{fill:#ff8f6f}.cls-17{fill:#003b94}.cls-18{fill:#3e2928}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mention_isometric-2",
    "data-name": "mention isometric-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mention_isometric",
    "data-name": "mention isometric"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M114.92 177.69 4.61 112.51c-3.52-2-6.53-5.21-3.11-7.33l110.72-63.79c1.65-1 4.18-1.7 5.87-.72l115.78 67.19c3.52 2 4.15 7.72.65 9.78l-105.06 60a14.67 14.67 0 0 1-14.54.05Z",
    style: {
      fill: "#5b36a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy",
    d: "M114.92 174.68 4.61 109.5c-3.52-2-6.53-5.21-3.11-7.33l110.72-63.79c1.65-1 4.18-1.7 5.87-.72l115.78 67.19c3.52 2 4.15 7.72.65 9.78l-105.06 60a14.67 14.67 0 0 1-14.54.05Z",
    style: {
      fill: "#6862e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "m124 88.69-21.75 12.41s33.53 20.46 40.39 23.34l12.54-18",
    style: {
      fill: "url(#linear-gradient)",
      isolation: "isolate",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "m116.5 148.26-21.77-12.39L73 148.29s11.34 6.92 22.18 13.27c6.82-4.87 13.72-9.79 21.32-13.3Z",
    style: {
      fill: "url(#linear-gradient-2)",
      isolation: "isolate",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "m69.59 71.73-13.81 7.88s1.17 7.22 8 10.11l18.11-11.58",
    style: {
      opacity: 0.46,
      fill: "url(#linear-gradient-3)",
      isolation: "isolate"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "cls-6",
    cx: 76.35,
    cy: 73.75,
    rx: 8.33,
    ry: 5.86
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 76.34,
    cy: 70.29,
    rx: 6.24,
    ry: 2.55,
    style: {
      fill: "#974c26"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-8",
    d: "M76.12 66c0-1.15 0-2.3-.13-3.45l-.09-.9-.06-.58a3.49 3.49 0 0 0-.09-.6l-.12-.7a27.53 27.53 0 0 0-4.45-10.89 16 16 0 0 0-1.25 6.37c0 .65.06 1.29.11 1.9v.37c0 .31.11.65.17.93a27.17 27.17 0 0 0 1 3.45 20.33 20.33 0 0 0 1.35 3c.57 1.09 1.18 2.15 1.85 3.19.51.81 1 1.53 1.49 2.22a41.69 41.69 0 0 0 .22-4.31Zm-3.28-12.91a1.14 1.14 0 0 0 0-.45c.16.16.32.33.47.5a1.24 1.24 0 0 0-.47 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-8",
    d: "M78.26 66.92a31.43 31.43 0 0 0 1.75-3c.15-.27.28-.53.42-.8l.26-.53.25-.55c.09-.22.19-.44.28-.65a27.49 27.49 0 0 0 2.14-11.57 15.85 15.85 0 0 0-4.5 4.69c-.34.54-.65 1.09-.94 1.65l-.13.24v.1l-.36.87a25.67 25.67 0 0 0-1 3.44 21.35 21.35 0 0 0-.5 3.27c-.11 1.22-.17 2.44-.17 3.67 0 1 0 1.83.06 2.67.8-1.12 1.66-2.29 2.44-3.5Zm4.24-12.66a1 1 0 0 0 .22-.4c0 .23.09.44.12.65a1.2 1.2 0 0 0-.34-.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-8",
    d: "M78.21 69.79c.65-.33 1.29-.67 1.93-1.05l.49-.29.31-.2.31-.22.36-.26a17.36 17.36 0 0 0 4.89-5.55 10.2 10.2 0 0 0-3.94 1.08c-.35.18-.69.38-1 .59l-.15.09-.48.36a16 16 0 0 0-1.67 1.52 14.38 14.38 0 0 0-1.32 1.6c-.46.65-.88 1.29-1.29 1.93s-.58 1-.83 1.47c.75-.31 1.58-.67 2.39-1.07Zm6.38-5.47a.77.77 0 0 0 .25-.14c0 .14-.1.27-.16.4a.58.58 0 0 0-.09-.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    className: "cls-8",
    d: "M76.12 66c0-1.15 0-2.3-.13-3.45l-.09-.9-.06-.58a3.49 3.49 0 0 0-.09-.6l-.12-.7a27.53 27.53 0 0 0-4.45-10.89 16 16 0 0 0-1.25 6.37c0 .65.06 1.29.11 1.9v.37c0 .31.11.65.17.93a27.17 27.17 0 0 0 1 3.45 20.33 20.33 0 0 0 1.35 3c.57 1.09 1.18 2.15 1.85 3.19.51.81 1 1.53 1.49 2.22a41.69 41.69 0 0 0 .22-4.31Zm-3.28-12.91a1.14 1.14 0 0 0 0-.45c.16.16.32.33.47.5a1.24 1.24 0 0 0-.47 0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    className: "cls-8",
    d: "M78.26 66.92a31.43 31.43 0 0 0 1.75-3c.15-.27.28-.53.42-.8l.26-.53.25-.55c.09-.22.19-.44.28-.65a27.49 27.49 0 0 0 2.14-11.57 15.85 15.85 0 0 0-4.5 4.69c-.34.54-.65 1.09-.94 1.65l-.13.24v.1l-.36.87a25.67 25.67 0 0 0-1 3.44 21.35 21.35 0 0 0-.5 3.27c-.11 1.22-.17 2.44-.17 3.67 0 1 0 1.83.06 2.67.8-1.12 1.66-2.29 2.44-3.5Zm4.24-12.66a1 1 0 0 0 .22-.4c0 .23.09.44.12.65a1.2 1.2 0 0 0-.34-.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    className: "cls-8",
    d: "M78.21 69.79c.65-.33 1.29-.67 1.93-1.05l.49-.29.31-.2.31-.22.36-.26a17.36 17.36 0 0 0 4.89-5.55 10.2 10.2 0 0 0-3.94 1.08c-.35.18-.69.38-1 .59l-.15.09-.48.36a16 16 0 0 0-1.67 1.52 14.38 14.38 0 0 0-1.32 1.6c-.46.65-.88 1.29-1.29 1.93s-.58 1-.83 1.47c.75-.31 1.58-.67 2.39-1.07Zm6.38-5.47a.77.77 0 0 0 .25-.14c0 .14-.1.27-.16.4a.58.58 0 0 0-.09-.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "m132.66 83.84-12 5.79a2.75 2.75 0 0 0-1.61 2.37 2.79 2.79 0 0 0 1.37 2.51L149 111.18a2.77 2.77 0 0 0 3.73-.9l6.94-10.79",
    style: {
      fill: "#a1482d"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    className: "cls-10",
    d: "M198.19 55.92 102.12.58a4.33 4.33 0 0 0-6.49 3.75v57.58a3.59 3.59 0 0 0 1.8 3.09l102.42 59.1a2.31 2.31 0 0 0 3.48-2V64.78a10.21 10.21 0 0 0-5.14-8.86Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    className: "cls-11",
    d: "m102.13 4.93 93.17 53.59a6.54 6.54 0 0 1 3.27 5.66v43.16a2.36 2.36 0 0 1-3.53 2L100 54.9a2.34 2.34 0 0 1-1.18-2V6.83a2.2 2.2 0 0 1 3.28-1.9Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    "data-name": "Oval",
    cx: 140.89,
    cy: 84.06,
    rx: 2.03,
    ry: 2.32,
    transform: "rotate(-10.9 140.901 84.042)",
    style: {
      fill: "#ab643c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    style: {
      opacity: 0.32,
      fill: "url(#linear-gradient-4)",
      isolation: "isolate"
    },
    d: "m127.17 63.48 43.3 26.01 21.39-12.43-38.22-22.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "m180.68 58.31-46.81-28.54a1.62 1.62 0 0 0-2.43 1.46v16.26a1.69 1.69 0 0 0 .81 1.47l46.81 27.93a1.62 1.62 0 0 0 1.61 0 1.64 1.64 0 0 0 .8-1.4l.24-15.16a2.27 2.27 0 0 0-1.03-2.02Z",
    style: {
      fill: "#e2ac00"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    className: "cls-11",
    d: "M169.48 66.67c1.68 2.35 4.63 3 6.58 1.48s2.19-4.68.51-7-4.63-3-6.59-1.47-2.18 4.65-.5 6.99Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    className: "cls-15",
    d: "m164.89 55.41-19.1-11.5a.73.73 0 0 0-.73 1.25l19.09 11.49a.73.73 0 0 0 .74-1.24Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    "data-name": "Path",
    className: "cls-15",
    d: "m164.1 60.08-26.32-15.84a.72.72 0 0 0-.87.33.72.72 0 0 0 .17.91l26.29 15.85a.72.72 0 0 0 .93-.29.73.73 0 0 0-.2-1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    "data-name": "Path",
    className: "cls-10",
    d: "m171.34 61.46-46.79-28.53a1.62 1.62 0 0 0-2.43 1.46v16.25a1.69 1.69 0 0 0 .81 1.47L169.74 80a1.6 1.6 0 0 0 2.41-1.44l.25-15.15a2.28 2.28 0 0 0-1.06-2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    "data-name": "Path",
    className: "cls-11",
    d: "M160.14 69.83c1.68 2.34 4.63 3 6.58 1.47s2.19-4.68.51-7-4.63-3-6.59-1.47-2.18 4.65-.5 7Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    "data-name": "Path",
    className: "cls-15",
    d: "m155.54 58.56-19.1-11.49a.72.72 0 0 0-.73 1.24l19.09 11.5a.73.73 0 0 0 .93-.29.72.72 0 0 0-.2-1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    "data-name": "Path",
    className: "cls-15",
    d: "m154.75 63.26-26.31-15.87a.72.72 0 0 0-.93.29.73.73 0 0 0 .2 1L154 64.48a.72.72 0 0 0 .93-.29.73.73 0 0 0-.2-1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    "data-name": "Path",
    className: "cls-6",
    d: "m159.6 63.37-46.8-28.52a1.61 1.61 0 0 0-2.43 1.46v16.25a1.7 1.7 0 0 0 .82 1.46L158 82a1.61 1.61 0 0 0 2.42-1.44l.24-15.15a2.3 2.3 0 0 0-1.05-2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path-18",
    "data-name": "Path",
    className: "cls-6",
    d: "m159.6 63.37-46.8-28.52a1.61 1.61 0 0 0-2.43 1.46v16.25a1.7 1.7 0 0 0 .82 1.46L158 82a1.61 1.61 0 0 0 2.42-1.44l.24-15.15a2.3 2.3 0 0 0-1.05-2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path-19",
    "data-name": "Path",
    className: "cls-11",
    d: "M148.39 71.74c1.68 2.35 4.63 3 6.59 1.47s2.18-4.67.5-7-4.63-3-6.59-1.47-2.16 4.65-.5 7Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path-20",
    "data-name": "Path",
    className: "cls-15",
    d: "M143.8 60.47 124.7 49a.73.73 0 0 0-.73 1.25l19.09 11.49a.71.71 0 0 0 .93-.29.72.72 0 0 0-.2-1Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path-21",
    "data-name": "Path",
    className: "cls-15",
    d: "m143 65.15-26.31-15.84a.73.73 0 0 0-.73 1.25l26.31 15.84a.73.73 0 0 0 .74-1.25Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    "data-name": "Path",
    className: "cls-16",
    d: "M98.18 61.78a22.75 22.75 0 0 0-6.63 9.72C89.22 77.93 95 88.44 95 88.44l9.06-7.17"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path-23",
    "data-name": "Path",
    className: "cls-17",
    d: "m97.2 146.8-2.46-1.35.65-3.52s3.66.35 4 1.65"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path-24",
    "data-name": "Path",
    className: "cls-10",
    d: "M98.1 146.75c.56-.34 1.13-.64 1.71-.94 1.42-.78 3.47-1.59 4.35-3.05a1.69 1.69 0 0 0-.12-1.92c-1.29-1.56-4.1 1-5.55-.73-.28-.34-.41-5.74-.41-5.74l-5.48 1.47s-.93 10.87-.83 11.54 2 1.29 2 1.29a4.76 4.76 0 0 0 1.58-.65c.58-.41 0-5.51.79-4.8s1.05 3.51 1.05 3.51a4.06 4.06 0 0 0 .91.02Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    "data-name": "Path",
    className: "cls-17",
    d: "m107.67 152.06-2.46-1.34.64-3.51s3.66.35 4 1.64"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path-26",
    "data-name": "Path",
    className: "cls-10",
    d: "M108.59 152c.56-.35 1.14-.65 1.71-.95 1.42-.78 3.47-1.58 4.35-3a1.71 1.71 0 0 0-.12-1.93c-1.29-1.56-4.1 1-5.54-.72-.29-.34-.42-5.75-.42-5.75l-5.48 1.48s-.94 10.91-.83 11.55 2 1.28 2 1.28a4.62 4.62 0 0 0 1.58-.64c.57-.42 0-5.52.78-4.8s1.06 3.5 1.06 3.5a3.54 3.54 0 0 0 .91-.02Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path-27",
    "data-name": "Path",
    className: "cls-18",
    d: "m89.81 116.73-1.61 21.58s2.57 3.55 11.2 1.58l.08-14.55"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path-28",
    "data-name": "Path",
    className: "cls-18",
    d: "M99.77 121c-.18 1.86 0 22.36 0 22.36s2.39 4.47 12.78 0l-.15-17.42"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path-29",
    "data-name": "Path",
    className: "cls-18",
    d: "M89 123.86c.7.49.95-2 1.69-1.6a41.51 41.51 0 0 0 8.53 3.74h.06a.61.61 0 0 1 .46 0 .58.58 0 0 1 .33.32 46.18 46.18 0 0 0 5.59 1.28c2.43.39 4.43-1.4 6.92-1.53 0-9.53 0-36.65-4-42.44l-12-4c-.06 1-5.83 7.68-5.69 15.83a183.16 183.16 0 0 1-1.24 20.74c-.05.44-.65 7.14-.65 7.66Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path-30",
    "data-name": "Path",
    className: "cls-16",
    d: "m109.67 72.66-1.1 10.93s-9 .36-12.82-2.3V72"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-31",
    "data-name": "Path",
    d: "m121.07 65.46-.92 1.25a28.42 28.42 0 0 0 1.29-3.12c.26-.72-.91-1-1.16-.29l-.14.38c.11-.39.22-.78.32-1.17a.6.6 0 0 0-1.17-.29 28.59 28.59 0 0 1-.91 3 21.36 21.36 0 0 0 .43-2.64c.08-.76-1.13-.73-1.2 0a18.93 18.93 0 0 1-.54 3 6.06 6.06 0 0 0-.09-1 .6.6 0 0 0-.26-.43c0-.13-.07-.26-.11-.4a.62.62 0 0 0-.67-.4.6.6 0 0 0-.51.58l-.08 4.5a5.21 5.21 0 0 1-.84 1.29 19 19 0 0 1 1.67 1.28 16.59 16.59 0 0 1 1.37 1.28c.38-.48.75-1 1.11-1.46l.12-.13q1.6-2.39 3.32-4.68c.47-.57-.58-1.16-1.03-.55Z",
    style: {
      fill: "#ffb5a9"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path-32",
    "data-name": "Path",
    className: "cls-16",
    d: "M104 62.69s4.23 1.14 6 3.86a48.49 48.49 0 0 1 2.83 5.85l3.13-4.86s3.8 1.17 5.3 3c0 0-4.5 9.84-8.43 10.68s-8.09-5.77-8.09-5.77-.86 2.76-.69-.19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-33",
    "data-name": "Path",
    d: "M106.68 73.21a8.68 8.68 0 0 1-2.68-3.82c-.5-1.73.13-3.25.72-4.86a15.32 15.32 0 0 0 1.11-5 50.08 50.08 0 0 0-.26-5 .81.81 0 0 1 0-.22c-.56-1.9-1.72-3.51-4-3.7-5.91-.5-6.25 6-6.2 8.71s.32 4.46-1.64 5.57-3.38 4-1.5 6.4.19 1.49-1.06 3.59-.92 4.71 1.64 5.66 14.46-.83 15.55-1.93a2.26 2.26 0 0 0 .56-1.61 6.24 6.24 0 0 0-2.23-3.75Z",
    style: {
      fill: "#007f68"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    className: "cls-10",
    d: "M112.49 19.21a9.47 9.47 0 0 1 1.67 4.89 3.18 3.18 0 0 1-.54 2.28 1.33 1.33 0 0 1-1.6.28 2.51 2.51 0 0 1-.86-.58 2.89 2.89 0 0 1-.55-.7l-.16-.3a1.07 1.07 0 0 1-.15.22 1.18 1.18 0 0 1-.53.22 1.63 1.63 0 0 1-1-.11 3.64 3.64 0 0 1-1.69-1.51 4.84 4.84 0 0 1-.74-2.44 2.36 2.36 0 0 1 .6-1.93 1.39 1.39 0 0 1 1.56-.25 2.67 2.67 0 0 1 .7.44 2.47 2.47 0 0 1 .46.51l.12.21v-.58l1.29.5.12 3.62a1.38 1.38 0 0 0 .24.73 1.19 1.19 0 0 0 .52.47c.62.24.91-.3.87-1.61a7 7 0 0 0-1.25-3.64 6 6 0 0 0-2.85-2.43 2.41 2.41 0 0 0-2.67.34 3.67 3.67 0 0 0-1 3 7.69 7.69 0 0 0 1.29 3.85 5.88 5.88 0 0 0 2.75 2.58 3.28 3.28 0 0 0 1.28.25 1.73 1.73 0 0 0 .84-.16l.26-.14.77 1.45-.12.09a3.26 3.26 0 0 1-.38.18 2.52 2.52 0 0 1-.65.18 3 3 0 0 1-.85 0 4.48 4.48 0 0 1-1.09-.28 7 7 0 0 1-2.57-1.89 11.1 11.1 0 0 1-2-3.11 9.58 9.58 0 0 1-.82-3.46 5.51 5.51 0 0 1 .59-2.9 3.24 3.24 0 0 1 1.83-1.6 3.46 3.46 0 0 1 2.53.13 8.16 8.16 0 0 1 3.77 3.22Zm-2.83 4.58a1.32 1.32 0 0 0 .26-1 2.55 2.55 0 0 0-.34-1.19 1.66 1.66 0 0 0-.78-.7.68.68 0 0 0-.79.1 1.14 1.14 0 0 0-.28.93 2.41 2.41 0 0 0 .36 1.2 1.71 1.71 0 0 0 .82.73.65.65 0 0 0 .75-.11"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    className: "cls-10",
    d: "M188.44 88.85a9.41 9.41 0 0 1 1.67 4.89 3.19 3.19 0 0 1-.54 2.28 1.33 1.33 0 0 1-1.6.27 2.49 2.49 0 0 1-.86-.57 3.14 3.14 0 0 1-.55-.71l-.16-.3a1.07 1.07 0 0 1-.15.22 1.19 1.19 0 0 1-.53.23 1.63 1.63 0 0 1-.95-.11 3.6 3.6 0 0 1-1.68-1.52 4.73 4.73 0 0 1-.75-2.44 2.38 2.38 0 0 1 .59-1.93 1.37 1.37 0 0 1 1.56-.25 2.13 2.13 0 0 1 .7.44 2.85 2.85 0 0 1 .47.51l.12.21v-.57l1.28.49.13 3.62a1.43 1.43 0 0 0 .23.72 1.15 1.15 0 0 0 .53.47c.65.25.91-.29.87-1.61a6.88 6.88 0 0 0-1.24-3.63 6.11 6.11 0 0 0-2.84-2.43 2.42 2.42 0 0 0-2.68.33 3.67 3.67 0 0 0-1 3 7.6 7.6 0 0 0 1.29 3.85 5.9 5.9 0 0 0 2.78 2.49 3.29 3.29 0 0 0 1.28.26 1.85 1.85 0 0 0 .84-.15l.26-.15.77 1.45-.12.09a3.26 3.26 0 0 1-.38.18 2.52 2.52 0 0 1-.65.18 3.1 3.1 0 0 1-.86 0 4.52 4.52 0 0 1-1.08-.28 7.07 7.07 0 0 1-2.57-1.89 11 11 0 0 1-2-3.12 9.33 9.33 0 0 1-.82-3.45 5.46 5.46 0 0 1 .59-2.89 3.31 3.31 0 0 1 1.83-1.62 3.59 3.59 0 0 1 2.54.13 8.22 8.22 0 0 1 3.68 3.31Zm-2.84 4.57a1.26 1.26 0 0 0 .27-1 2.48 2.48 0 0 0-.34-1.19 1.61 1.61 0 0 0-.77-.71.71.71 0 0 0-.8.1 1.2 1.2 0 0 0-.29.93 2.52 2.52 0 0 0 .37 1.19 1.73 1.73 0 0 0 .82.74.64.64 0 0 0 .74-.11"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-34",
    "data-name": "Path",
    d: "m60.25 116.27-21.77-12.39-21.77 12.41s12.11 7.57 22.95 13.92c6.89-4.86 13-10.42 20.59-13.94Z",
    style: {
      fill: "url(#linear-gradient-5)",
      isolation: "isolate",
      opacity: 0.25
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path-6-2",
    "data-name": "path-6",
    style: {
      fillRule: "evenodd"
    },
    d: "M20.93 81.47v26.94l20.98 12.01 23.7-14.01V79.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-6-3",
    "data-name": "path-6",
    style: {
      fill: "#ff9271",
      fillRule: "evenodd"
    },
    d: "M20.93 81.47v26.94l20.98 12.01 23.7-14.01V79.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-35",
    "data-name": "Path",
    style: {
      fill: "#df5c34"
    },
    d: "M41.91 93.49v26.93l23.7-14.01V79.48l-23.7 14.01z"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path-36",
    "data-name": "Path",
    className: "cls-10",
    d: "m20.93 81.47 24.35-13.88 20.33 11.89-23.7 14.01-20.98-12.02z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    className: "cls-18",
    d: "M42.47 73.78a12.91 12.91 0 0 1 7.1 1.56c1.25.73 1.93 1.49 2 2.29a2.1 2.1 0 0 1-1.28 2.07 4.69 4.69 0 0 1-1.49.59 5.42 5.42 0 0 1-1.33.14h-.48a1.89 1.89 0 0 1 .09.34 1.64 1.64 0 0 1-.26.77 2.91 2.91 0 0 1-1.05 1 6.34 6.34 0 0 1-3.35.88 6.63 6.63 0 0 1-3.42-.88 2.64 2.64 0 0 1-1.55-2.08 2.25 2.25 0 0 1 1.28-2 4.26 4.26 0 0 1 1.14-.46 4.35 4.35 0 0 1 1-.17h.35l-.64-.39 1.8-1.12 4.17 2.46a2.19 2.19 0 0 0 2.08 0c.88-.56.56-1.28-.95-2.18a9.63 9.63 0 0 0-5.28-1.17A10.81 10.81 0 0 0 36.91 77c-1.51 1-2.26 2.07-2.25 3.38s.8 2.43 2.36 3.34A10.53 10.53 0 0 0 42.59 85a10.46 10.46 0 0 0 5.51-1.46 6.28 6.28 0 0 0 1.53-1.28 2.94 2.94 0 0 0 .64-1.09l.09-.41 2.38.14v.21a5.54 5.54 0 0 1-.17.58 5.22 5.22 0 0 1-.41.86 6.25 6.25 0 0 1-.85 1 8 8 0 0 1-1.38 1.07 12.92 12.92 0 0 1-4.66 1.68 17.72 17.72 0 0 1-5.44.09 12.46 12.46 0 0 1-4.67-1.52 6.12 6.12 0 0 1-2.65-2.79 4.09 4.09 0 0 1 0-3.29 6.28 6.28 0 0 1 2.63-2.88 14.41 14.41 0 0 1 7.33-2.14Zm2.33 6.63a1.34 1.34 0 0 0-.8-1 3.24 3.24 0 0 0-1.66-.41 2.79 2.79 0 0 0-1.55.4 1.13 1.13 0 0 0-.64 1 1.27 1.27 0 0 0 .75 1 3.36 3.36 0 0 0 1.7.43 3.13 3.13 0 0 0 1.63-.43 1 1 0 0 0 .6-1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationWomanOnlineMobile);
export default __webpack_public_path__ + "static/media/illustration-woman-online-mobile.fe928f9c476ef6d332672b3ab38268fd.svg";
export { ForwardRef as ReactComponent };